
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[areaId]",
      function () {
        return require("private-next-pages/[areaId]/index.tsx");
      }
    ]);
  